(()=>{'use strict';
const normalize=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/ς/g,'σ').trim();
class LabCollectionSearch extends HTMLElement{
 connectedCallback(){
  if(this.abort)return;
  this.abort=new AbortController();const signal=this.abort.signal;
  this.section=this.closest('.collection-main');this.input=this.querySelector('input[type="search"]');
  this.grid=this.section.querySelector('.product-grid');this.pagination=this.section.querySelector('.pagination');
  this.count=this.section.querySelector('.collection-tools>p');this.originalCount=this.count.textContent;
  this.originalCards=[...this.grid.childNodes];this.status=this.querySelector('[data-search-status]');this.clear=this.querySelector('[data-search-clear]');
  this.more=this.section.querySelector('[data-search-more]');this.sequence=0;this.hidden=false;
  this.querySelector('form').addEventListener('submit',e=>{e.preventDefault();clearTimeout(this.timer);this.run()},{signal});
  this.input.addEventListener('input',()=>{clearTimeout(this.timer);this.sequence++;this.timer=setTimeout(()=>this.run(),180)},{signal});
  this.clear.addEventListener('click',()=>{this.input.value='';clearTimeout(this.timer);this.run();this.input.focus()},{signal});
  this.input.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();this.clear.click()}},{signal});
  this.more.addEventListener('click',()=>{this.limit+=24;this.paint()},{signal});
  this.filterForm=this.section.querySelector('.filter-form');
  if(this.filterForm){this.filterQuery=document.createElement('input');this.filterQuery.type='hidden';this.filterQuery.name='lab_q';this.filterForm.append(this.filterQuery)}
  this.section.addEventListener('click',e=>{const a=e.target.closest('.active-filters a');if(!a)return;const url=new URL(a.href);const q=this.input.value.trim();if(q)url.searchParams.set('lab_q',q);else url.searchParams.delete('lab_q');a.href=url.href},{signal});
  this.input.value=new URL(location.href).searchParams.get('lab_q')||'';
  if(this.input.value)this.run();
 }
 async load(){
  if(this.catalog)return this.catalog;
  this.catalog=(async()=>{
   const products=[];let page=1,pages=1,total=0;
   do{
    const url=new URL(location.href);url.searchParams.delete('lab_q');url.searchParams.delete('section_id');url.searchParams.set('view','lab-search');url.searchParams.set('page',page);
    const response=await fetch(url,{signal:this.abort.signal});if(!response.ok)throw Error('catalog');
    const data=await response.json();if(!Array.isArray(data.products)||data.page!==page||data.pages>100)throw Error('catalog');
    pages=data.pages;total=data.total;products.push(...data.products);page++;
   }while(page<=pages);
   const unique=[...new Map(products.map(p=>[p.id,p])).values()];if(unique.length!==total)throw Error('incomplete');
   return unique;
  })().catch(error=>{this.catalog=null;throw error});
  return this.catalog;
 }
 async run(){
  const id=++this.sequence,q=this.input.value.trim();this.clear.hidden=!q;
  const url=new URL(location.href);if(q)url.searchParams.set('lab_q',q);else url.searchParams.delete('lab_q');history.replaceState(history.state,'',url);
  if(this.filterQuery){this.filterQuery.value=q;this.filterQuery.disabled=!q}
  if(!q){this.restore();this.status.textContent='';this.grid.removeAttribute('aria-busy');return}
  this.status.textContent=this.dataset.loading;this.grid.setAttribute('aria-busy','true');
  try{
   const products=await this.load();if(id!==this.sequence||!this.isConnected)return;
   const needle=normalize(q),code=needle.replace(/^(κωδ(?:ικοσ)?\.?|code)\s*/,'');const terms=needle.split(/\s+/);
   this.matches=products.filter(p=>/^\d+$/.test(code)?p.code&&Number(p.code)===Number(code):terms.every(term=>normalize(p.title+' '+p.vendor+' '+p.code).includes(term)));
   this.limit=24;this.paint();
  }catch(error){if(id===this.sequence&&error.name!=='AbortError'){this.restore();this.status.textContent=this.dataset.error}}
  finally{if(id===this.sequence)this.grid.removeAttribute('aria-busy')}
 }
 restore(){this.grid.replaceChildren(...this.originalCards);this.pagination.hidden=false;this.more.hidden=true;this.count.textContent=this.originalCount}
 paint(){
  const template=document.createElement('template');template.innerHTML=this.matches.slice(0,this.limit).map(p=>p.html).join('');this.grid.replaceChildren(template.content);
  this.pagination.hidden=true;this.more.hidden=this.matches.length<=this.limit;
  const message=this.matches.length===1?this.dataset.resultOne:this.matches.length?this.dataset.results.replace('{count}',this.matches.length):this.dataset.empty;
  this.status.textContent=message;this.count.textContent=this.matches.length+' '+(this.matches.length===1?this.dataset.countOne:this.dataset.count);
 }
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.abort=null;this.catalog=null;this.filterQuery?.remove()}
}
if(!customElements.get('lab-collection-search'))customElements.define('lab-collection-search',LabCollectionSearch);
})();
